module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (this.$store.state.is_auth && this.$store.state.user_type === 'client') ? _c('div', [(!_vm.form_ErrorMessage) ? [_c('transition', {
    key: "transitionError",
    attrs: {
      "name": "fadeControl"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.localErrorMessage !== ''),
      expression: "localErrorMessage !== ''"
    }],
    staticClass: "alert alert-danger margin-20-0",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm._f("ftc")(_vm.localErrorMessage)) + "\n\t\t\t\t"), _c('button', {
    staticClass: "close",
    attrs: {
      "title": _vm._f("ftc")('main/close')
    },
    on: {
      "click": function($event) {
        _vm.localErrorMessage = ''
      }
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('h3', [_vm._v("Пользователи аккаунта")]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(0)] : _vm._e()], 2) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("\n\t\t\t\tLorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque ultrices sollicitudin metus, non finibus nisi pellentesque rhoncus. Fusce et erat laoreet, elementum erat non, tincidunt risus. Aliquam et condimentum sem. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Duis dolor justo, blandit ac purus non, convallis porttitor mauris. Nulla cursus, nulla ac hendrerit mollis, turpis magna eleifend diam, et luctus nisi ligula quis ipsum. Integer ut interdum tortor.\n\t\t\t")]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\tSed ut est in orci interdum dapibus a eu arcu. Sed eget tortor velit. Fusce vitae justo at tortor posuere finibus id et massa. Cras lacinia risus euismod, consectetur eros blandit, vehicula sem. Suspendisse ipsum neque, faucibus ac hendrerit consequat, tempor eu justo. Suspendisse est orci, porttitor id risus at, mattis varius diam. Aenean malesuada eros accumsan sem efficitur imperdiet id et lorem. Aliquam erat volutpat. Suspendisse et eros eu erat tincidunt aliquam consequat quis mi. Sed nulla augue, ultricies nec odio ac, pretium ornare eros. Suspendisse potenti. Praesent iaculis, orci vitae lacinia venenatis, metus leo egestas libero, ut congue velit lorem aliquam ante. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Maecenas ultrices tellus ut nibh fringilla, ac finibus velit euismod. Proin rutrum dictum augue eget sodales. Nam ultrices nulla sed massa lacinia feugiat in nec nulla.\n\t\t\t")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18cd3000"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/crud/Users.vue
// module id = 720
// module chunks = 0